import { IIconProps } from './icon';

interface IIconTransactionsProps extends IIconProps {
  fill?: string;
}

export const IconTransactions = ({
  style = {},
  cy,
  fill = '#793EAD',
}: IIconTransactionsProps) => {
  return (
    <svg
      width="44"
      height="48"
      viewBox="0 0 44 48"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconFiltersMap${cy}`}
    >
      <path d="M34.4882 36.7744C25.2918 40.4203 15.8998 39.2694 11.2686 34.0965C11.4428 35.1476 11.7596 36.1633 12.2256 37.136C15.7477 44.4863 26.6098 46.663 37.2144 42.4573L39.463 47.1498L43.3762 35.9219L32.2146 32.023L34.4903 36.7722L34.4882 36.7744Z" />
      <path d="M8.97222 10.1515C17.8759 5.83493 27.3275 6.28745 32.327 11.1033C32.0759 10.0681 31.6853 9.0786 31.1489 8.14306C27.0954 1.0736 16.102 -0.293103 5.83509 4.686L3.24727 0.172747L0.170554 11.6595L11.5893 14.7216L8.97023 10.1538L8.97222 10.1515Z" />
      <path d="M26.2863 20.6261C24.9218 19.8888 23.1984 19.6008 21.4048 19.3475C20.7991 19.2624 20.5261 19.0191 20.49 18.8765C20.4496 18.7162 20.6121 18.294 21.2196 17.8425C22.7718 16.6892 25.0199 18.5126 25.0425 18.531L26.3332 16.9658L27.6334 15.4085C27.5183 15.3114 26.4653 14.4421 24.9641 13.878C24.79 13.8127 24.6161 13.756 24.4428 13.704V12.4316H20.4V13.7286C19.8426 13.925 19.3119 14.2037 18.819 14.5698C16.9282 15.9739 16.0881 17.9575 16.5717 19.8757C17.0385 21.7286 18.6756 23.0696 20.8439 23.3754C24.9517 23.9549 24.8878 24.4788 24.8075 25.1426C24.7711 25.4428 24.6458 25.8732 23.9825 26.1446C22.9114 26.5823 20.9024 26.361 19.0211 24.8395L16.4887 28.0102C17.6953 28.9859 19.0424 29.679 20.4002 30.0624V31.5802H24.4431V30.2409C24.8086 30.16 25.1641 30.0521 25.5053 29.9125C27.3749 29.1475 28.5832 27.5888 28.8204 25.6356C29.0875 23.4324 28.1878 21.653 26.2863 20.6261Z" />
    </svg>
  );
};
